import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { ChallengeOnboardingRoutingModule } from "./challenge-onboarding-routing.module";
import { ChallengeOnboardingPage } from "./challenge-onboarding.page";
import { AssesmentPageModule } from "src/app/modals/assesment/assesment.module";
import { ChallengeLayoutModule } from "src/app/components/challenge-layout/challenge-layout.module";

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, ChallengeOnboardingRoutingModule, AssesmentPageModule, ChallengeLayoutModule],
  declarations: [ChallengeOnboardingPage],
})
export class ChallengeOnboardingPageModule {}
